import {IllustrationProps, IllustrationsMap} from './illustrations_types';

export const Illustration = ({
  id,
  className,
  imgName = 'success',
  size = 142,
  containerStyle,
}: IllustrationProps) => {
  return (
    <img
      id={id}
      className={className}
      style={{width: size, height: size, ...containerStyle}}
      src={IllustrationsMap[imgName]}
    />
  );
};

export default Illustration;
